// import { StandaloneSearchBox } from '@react-google-maps/api';
import { StoreLocatorActionTypes } from '@state/features/common.types';
import { setAddress } from '@state/features/storelocator.slice';
import analytics from '@utils/analytics';
import React, { useEffect, useLayoutEffect, useRef, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import whatInput from 'what-input';
import StoreLocatorFilters from './StoreLocatorFilters';
import StoreLocatorGeo from './StoreLocatorGeo';
import StoreLocatorRegions from './StoreLocatorRegions';
import StoreLocatorResults from './StoreLocatorResults';
import { autoChooseClassnames, autoChooseProps, getId } from '@common/utils/brandDiffsUtils';
import { useElementSize } from 'usehooks-ts';
import StoreLocatorSearchBox from './StoreLocatorSearchBox';
import { createPortal } from 'react-dom';
const StoreLocatorSearch = (props) => {
    const { t } = useTranslation();
    const { filteredStores } = props;
    const dispatch = useDispatch();
    const { stores, address, filters } = useSelector((state) => state.storelocator);
    const initalSearchValue = props.initialSearch ? props.initialSearch : address;
    const firstRender = useRef(true);
    const inputAutocomplateInstance = useRef(null);
    // const showResultslistRef = useRef<HTMLButtonElement>(null);
    const refineButton = useRef(null);
    const a11yBoutiqueRsults = useRef(null);
    const [showResultslist, setShowResultslist] = useState(false);
    const [showRegions, setShowRegions] = useState(false);
    const [showFilters, setShowFilters] = useState(false);
    const [searchText, setSearchText] = useState();
    const toggleFilters = (isEsc) => {
        let isShow = !showFilters;
        setShowFilters(isShow);
        if (!isShow && isEsc) {
            setTimeout(() => {
                var _a;
                (_a = refineButton.current) === null || _a === void 0 ? void 0 : _a.focus();
            }, 100);
        }
    };
    const [filtersRef, { width }] = useElementSize();
    const placeService = useMemo(() => new google.maps.places.PlacesService(document.createElement('div')), []);
    const filterNumber = useMemo(() => {
        var _a;
        return (((_a = filters.collections) === null || _a === void 0 ? void 0 : _a.length) || 0) + (filters.collections.length || 0);
    }, [filters]);
    const resetAutoFocus = () => {
        props.returnFocusElement && props.returnFocusElement(null);
    };
    useEffect(() => {
        // siamo nella city o country page
        // mostra la lista per avere gli url in pagina x SEO internal linking
        if (props.initialSearch) {
            setShowResultslist(true);
        }
    }, []);
    useEffect(() => {
        if (firstRender.current && initalSearchValue) {
            firstRender.current = false;
        }
    }, [initalSearchValue]);
    useLayoutEffect(() => {
        // Set a CSS variable used by input to make SI input layout responsive
        if (getId() === 'ST') {
            document.documentElement.style.setProperty(`--storelocator-filters-width`, `${width / 10}rem`);
        }
    }, [width]);
    useLayoutEffect(() => {
        if (a11yBoutiqueRsults.current) {
            let tmot;
            a11yBoutiqueRsults.current.innerText = '';
            tmot = setTimeout(() => {
                const label = filteredStores.length > 1 ? 'storelocator.nboutiques' : 'storelocator.nboutique';
                a11yBoutiqueRsults.current.innerText = filteredStores.length ? t(label, { 0: filteredStores.length }) : t('storelocator.noresults');
            }, 200);
            return () => {
                clearTimeout(tmot);
            };
        }
    }, [filteredStores, filterNumber]);
    const onLoad = (autocomplete) => {
        inputAutocomplateInstance.current = autocomplete;
    };
    const onPlaceChanged = async (places) => {
        var _a, _b, _c;
        if (inputAutocomplateInstance.current) {
            const selectedPlaces = places;
            if (selectedPlaces.length == 0) {
                dispatch(setAddress(undefined));
                return;
            }
            const bounds = new google.maps.LatLngBounds();
            selectedPlaces.forEach((place) => {
                if (!place.geometry || !place.geometry.location) {
                    console.log('Returned place contains no geometry');
                    return;
                }
                if (place.geometry.viewport) {
                    // Only geocodes have viewport.
                    bounds.union(place.geometry.viewport);
                }
                else {
                    bounds.extend(place.geometry.location);
                }
            });
            if (!!selectedPlaces[0].formatted_address) {
                analytics.storelocatorSearch(selectedPlaces[0].formatted_address);
                if (selectedPlaces[0].name === '') {
                    dispatch(setAddress(undefined));
                }
                else {
                    if (selectedPlaces[0].address_components) {
                        // se è una città
                        // props.searchedCity(undefined);
                        // if (selectedPlaces[0].address_components[0]?.types.includes('locality')) {
                        //   props.searchedCity(selectedPlaces[0].address_components[0]?.short_name);
                        // }
                        // se è una country
                        props.searchedCountry(undefined);
                        if ((_a = selectedPlaces[0].address_components[0]) === null || _a === void 0 ? void 0 : _a.types.includes('country')) {
                            props.searchedCountry((_b = selectedPlaces[0].address_components[0]) === null || _b === void 0 ? void 0 : _b.short_name);
                        }
                    }
                    else if ((_c = selectedPlaces[0].types) === null || _c === void 0 ? void 0 : _c.includes('country')) {
                        await new Promise((resolve) => {
                            placeService.getDetails(selectedPlaces[0], (result, status) => {
                                var _a;
                                if (status === google.maps.places.PlacesServiceStatus.OK) {
                                    console.log('result ', result);
                                    props.searchedCountry((_a = result.address_components[0]) === null || _a === void 0 ? void 0 : _a.short_name);
                                }
                                resolve(status);
                            });
                        });
                    }
                    dispatch(setAddress(selectedPlaces[0].formatted_address));
                    dispatch({ type: StoreLocatorActionTypes.UPDATE_BOUNDS, payload: { newBounds: bounds.toJSON(), fromSearch: true } });
                    // setTimeout(() => {
                    //   showResultslistRef.current?.focus();
                    // }, 2000);
                }
            }
        }
        else {
            console.log('Autocomplete is not loaded yet!');
        }
    };
    const onRegionClick = (places) => {
        if (places.length > 0) {
            onPlaceChanged(places);
            setSearchText(places[0].name);
        }
    };
    return (React.createElement("div", { className: "container container--search" },
        React.createElement("div", { className: "row justify-center" },
            React.createElement("div", { className: autoChooseClassnames({
                    /* eslint-disable  prettier/prettier */
                    MO: "col-12 col-sm-10 col-md-8 col-lg-6",
                    ST: "col-24 col-lg-20 col-xxl-12"
                }) },
                React.createElement("div", { className: "search-store" },
                    React.createElement(StoreLocatorSearchBox, { searchText: searchText, placeService: placeService, onLoad: onLoad, onPlacesChanged: onPlaceChanged, onInputFocus: () => {
                            resetAutoFocus();
                        }, onResetClick: () => {
                            props.returnFocusElement('searchinput');
                            dispatch(setAddress(undefined));
                            props.searchedCountry(undefined);
                        }, autoFocus: props.autofocusitem === 'searchinput', showResultslist: true }),
                    React.createElement("div", { className: "search-store__results-filters", ref: filtersRef },
                        React.createElement("div", { className: "search-store__resultslabel" },
                            createPortal(React.createElement("span", { className: 'visually-hidden', "aria-live": 'polite', "aria-relevant": 'text', ref: a11yBoutiqueRsults }), document.body),
                            filteredStores.length ? (address || filters.collections.length > 0 || filters.services.length > 0 || initalSearchValue ? (React.createElement("button", { type: "button", "aria-controls": "resultsOptions", className: "alllocations__toggle", onClick: () => {
                                    setShowFilters(false);
                                    setShowRegions(false);
                                    setShowResultslist(true);
                                }, "aria-haspopup": "dialog" }, t(filteredStores.length > 1 ? 'storelocator.nboutiques' : 'storelocator.nboutique', { 0: filteredStores.length }))) : (React.createElement("button", { type: "button", "aria-controls": "allLocationsOptions", className: "alllocations__toggle allocations__toggle--nosearch", onClick: () => {
                                    setShowFilters(false);
                                    setShowResultslist(false);
                                    setShowRegions(true);
                                }, "aria-haspopup": "dialog" }, autoChooseProps({
                                MO: t('storelocator.allnboutiques', { 0: stores.length }),
                                ST: t('storelocator.allboutiques')
                            })))) : (React.createElement("i", null, t('storelocator.noresults')))),
                        showResultslist ? React.createElement(StoreLocatorResults, { filteredStores: filteredStores, onItemClick: () => {
                                props.returnFocusElement && props.returnFocusElement('listbutton');
                            }, close: () => {
                                setShowResultslist(false);
                                dispatch(setAddress(undefined));
                                setShowRegions(true);
                            } }) : React.createElement("div", { id: "resultsOptions" }),
                        showRegions ? (React.createElement(StoreLocatorRegions, { onRegionClick: onRegionClick, placeService: placeService, filteredStores: stores, close: (selectedCountry) => {
                                setShowRegions(false);
                                if (selectedCountry && whatInput.ask() == 'keyboard') {
                                    setShowResultslist(true);
                                }
                                else {
                                    setTimeout(() => {
                                        var _a;
                                        (_a = document.querySelector('.alllocations__toggle')) === null || _a === void 0 ? void 0 : _a.focus();
                                    }, 0);
                                }
                            } })) : (React.createElement("div", { id: "allLocationsOptions" })),
                        getId() === 'MO' && React.createElement(StoreLocatorGeo, null),
                        React.createElement("button", { ref: refineButton, className: "refine__toggle", type: "button", "aria-expanded": showFilters, "aria-controls": "refineOptions", autoFocus: props.autofocusitem == 'refinement', onClick: () => {
                                if (!showFilters) {
                                    analytics.storelocatorOpenRefine();
                                }
                                toggleFilters();
                            }, onFocus: resetAutoFocus }, t('refine.title')),
                        showFilters ? React.createElement(StoreLocatorFilters, { close: toggleFilters }) : React.createElement("div", { id: "refineOptions" })))))));
};
StoreLocatorSearch.defaultProps = {
    autofocusitem: 'searchinput'
};
export default StoreLocatorSearch;
